import { Skeleton } from '@mui/material'
import { AppBox, AppTypography, ProfileInfoCardWithLinks, profilelink, TextWithToolTip } from 'components'
import { ApiQueryKeys, ContactDetailsElements, SideBarType } from 'globals/constants'
import { getMDYFormattedDate } from 'globals/functions'
import { useSnackbar } from 'notistack'
import { FC, useEffect, useMemo, useState } from 'react'
import { CrmContactsApi, CrmContactViewModel, ProfileImagePayload } from 'sdk'
import { scroller } from 'react-scroll'

interface Props {
  contact: CrmContactViewModel | undefined
  isGetting: boolean
}
export const CrmContactDetailSideBar: FC<Props> = ({ contact, isGetting }) => {
  const crmApi = new CrmContactsApi()
  const { enqueueSnackbar } = useSnackbar()
  const data: profilelink[] = [
    {
      name: 'Contact',
      icon: 'carbon:user-avatar',
      id: 'Contact',
      linkTo: ContactDetailsElements.PROFILE,
    },
    {
      name: 'Parks',
      icon: 'bi:people',
      id: 'Parks',
      linkTo: ContactDetailsElements.LINKEDPARKS,
    },
    {
      name: 'Companies',
      icon: 'fluent-mdl2:tab-center',
      id: 'Companies',
      linkTo: ContactDetailsElements.LINKEDCOMPANIES,
    },
    {
      name: 'Group Tags',
      icon: 'mdi:lock-open-outline',
      id: 'GroupTags',
      linkTo: ContactDetailsElements.LINKEDTAGS,
    },
    {
      name: 'Notes',
      icon: 'ph:question',
      id: 'Notes',
      linkTo: ContactDetailsElements.LINKEDNOTES,
    },
  ]
  const [image, setImage] = useState<string | null>()
  const handleImageSave = (imageSrc: string) => {
    setImage(imageSrc)
    enqueueSnackbar('Profile image updated successfully', { variant: 'success' })
  }
  const handleRemoveImage = () => {
    setImage(null)
    enqueueSnackbar('Profile image removed successfully', { variant: 'success' })
  }
  const handleScroll = (link: profilelink) => {
    scroller.scrollTo(link.linkTo!, {
      duration: 800, // Duration of the scroll animation (in ms)
      delay: 0, // Delay before scrolling starts (in ms)
      smooth: true, // Smooth scrolling effect
      offset: -50, // Offset to adjust scroll position (e.g., account for fixed headers)
    })
  }
  useEffect(() => {
    setImage(contact?.ContactProfilePicture)
  }, [contact])
  return (
    <ProfileInfoCardWithLinks
      isProfilePictureLoading={isGetting}
      links={data}
      sideBarType={SideBarType.CRMContact}
      onLinkClick={(link) => handleScroll(link)} // scroll bar
      principalId={contact?.Id!}
      imageSrc={image}
      defaultImage="/images/profile-image.png"
      onImageSave={handleImageSave}
      uploadImageFn={(data: ProfileImagePayload) => crmApi.updateUserProfileImage(data)}
      uploadImageFnKey={ApiQueryKeys.crm.contacts.UploadPicture}
      removeImageFn={() => crmApi.deleteContactProfilePicture(contact?.Id!)}
      removeImageFnKey={ApiQueryKeys.crm.contacts.RemovePicture}
      onRemoveImage={handleRemoveImage}
      contentInfo={
        <>
          {isGetting ? (
            <>
              <Skeleton height={40} width={150} />
              <Skeleton height={30} width={100} />
            </>
          ) : (
            <AppBox textAlign={'center'}>
              <AppTypography fontWeight={700} fontSize={18}>
                {(contact?.ContactFirstName ?? '') + ' ' + (contact?.ContactLastName ?? '')}
              </AppTypography>
              {contact?.ContactPhone && (
                <AppTypography color={'grey.800'} fontSize={14}>
                  {contact?.ContactPhone}
                </AppTypography>
              )}
              {contact?.ContactEmail && <AppTypography color={'grey.800'}>{contact?.ContactEmail}</AppTypography>}
              {contact?.Updated && (
                <AppTypography color={'grey.800'}>
                  Last Update {getMDYFormattedDate(new Date(contact?.Updated!))}
                </AppTypography>
              )}
            </AppBox>
          )}
        </>
      }
    />
  )
}
